import { createSelector } from '@reduxjs/toolkit';
import { SizingMethod } from 'client/voladeum/sizing-methods/types';
import { RootState } from 'store';

const sizingMethodsSlice = (state: RootState) => state.sizing_methods;

export const selectSizingMethods = createSelector(
  [sizingMethodsSlice],
  (state): SizingMethod[] => state
);
